/**
 * OneAmerica AssetCare Pricing Configuration
 * Auto-generated from linearity analysis of 895 quotes
 * Generated: 2026-02-11
 *
 * Contains premium band multipliers for 4 product types x 28 configs.
 * Multipliers correct for non-linear pricing when scaling from base premium.
 * Base premium: $100k (Single Pay), $10k (10-Pay)
 */

import { FundingPolicyType } from "@shared";

type BandEntry = { premium: number; multiplier: number };
type ConfigBands = Record<string, BandEntry[]>;

const OA_SINGLE_PAY_SINGLE_LIFE_BANDS: ConfigBands = {
  "None|None|2 Years": [
    { premium: 50000, multiplier: 0.999873 },
    { premium: 75000, multiplier: 0.999958 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999924 },
    { premium: 150000, multiplier: 0.999958 },
    { premium: 200000, multiplier: 0.999936 },
    { premium: 300000, multiplier: 0.999958 },
    { premium: 400000, multiplier: 1.017568 },
  ],
  "None|None|4 Years": [
    { premium: 50000, multiplier: 1.000131 },
    { premium: 75000, multiplier: 0.999956 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000026 },
    { premium: 150000, multiplier: 1.000044 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1 },
    { premium: 400000, multiplier: 1.021437 },
  ],
  "None|None|6 Years": [
    { premium: 50000, multiplier: 1.000143 },
    { premium: 75000, multiplier: 1.000048 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999971 },
    { premium: 150000, multiplier: 1.000048 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1 },
    { premium: 400000, multiplier: 1.023416 },
  ],
  "None|None|Lifetime": [
    { premium: 50000, multiplier: 1.000146 },
    { premium: 75000, multiplier: 0.999951 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000029 },
    { premium: 150000, multiplier: 1.000049 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.000049 },
    { premium: 400000, multiplier: 1.021627 },
  ],
  "None|2%|2 Years": [
    { premium: 50000, multiplier: 0.999869 },
    { premium: 75000, multiplier: 0.999956 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999921 },
    { premium: 150000, multiplier: 0.999956 },
    { premium: 200000, multiplier: 0.999934 },
    { premium: 300000, multiplier: 1.030565 },
    { premium: 400000, multiplier: 1.052735 },
  ],
  "None|2%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.037123 },
    { premium: 400000, multiplier: 1.0686 },
  ],
  "None|2%|6 Years": [
    { premium: 50000, multiplier: 1.000152 },
    { premium: 75000, multiplier: 1.000051 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.99997 },
    { premium: 150000, multiplier: 1.000051 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.041026 },
    { premium: 400000, multiplier: 1.105674 },
  ],
  "None|2%|Lifetime": [
    { premium: 50000, multiplier: 0.999845 },
    { premium: 75000, multiplier: 1.000052 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999969 },
    { premium: 150000, multiplier: 0.999948 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.038942 },
    { premium: 400000, multiplier: 1.110572 },
  ],
  "None|3%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999893 },
    { premium: 150000, multiplier: 0.999911 },
    { premium: 200000, multiplier: 1.008838 },
    { premium: 300000, multiplier: 1.053383 },
    { premium: 400000, multiplier: 1.075656 },
  ],
  "None|3%|4 Years": [
    { premium: 50000, multiplier: 1.00014 },
    { premium: 75000, multiplier: 1.000047 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000084 },
    { premium: 150000, multiplier: 1.000047 },
    { premium: 200000, multiplier: 1.004194 },
    { premium: 300000, multiplier: 1.067058 },
    { premium: 400000, multiplier: 1.09849 },
  ],
  "None|3%|6 Years": [
    { premium: 50000, multiplier: 1.000159 },
    { premium: 75000, multiplier: 1.000053 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000095 },
    { premium: 150000, multiplier: 1.000053 },
    { premium: 200000, multiplier: 1.000079 },
    { premium: 300000, multiplier: 1.091826 },
    { premium: 400000, multiplier: 1.156919 },
  ],
  "None|3%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1.000108 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000065 },
    { premium: 150000, multiplier: 1.000108 },
    { premium: 200000, multiplier: 1.000081 },
    { premium: 300000, multiplier: 1.093355 },
    { premium: 400000, multiplier: 1.165721 },
  ],
  "None|5%|2 Years": [
    { premium: 50000, multiplier: 1.00014 },
    { premium: 75000, multiplier: 0.999953 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000028 },
    { premium: 150000, multiplier: 1.012847 },
    { premium: 200000, multiplier: 1.058584 },
    { premium: 300000, multiplier: 1.104321 },
    { premium: 400000, multiplier: 1.12719 },
  ],
  "None|5%|4 Years": [
    { premium: 50000, multiplier: 1.000147 },
    { premium: 75000, multiplier: 0.999951 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000029 },
    { premium: 150000, multiplier: 1.004472 },
    { premium: 200000, multiplier: 1.067743 },
    { premium: 300000, multiplier: 1.131112 },
    { premium: 400000, multiplier: 1.162797 },
  ],
  "None|5%|6 Years": [
    { premium: 50000, multiplier: 0.999828 },
    { premium: 75000, multiplier: 1.000057 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999966 },
    { premium: 150000, multiplier: 0.999943 },
    { premium: 200000, multiplier: 1.064989 },
    { premium: 300000, multiplier: 1.200253 },
    { premium: 400000, multiplier: 1.267885 },
  ],
  "None|5%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1.000117 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.00007 },
    { premium: 150000, multiplier: 1.000117 },
    { premium: 200000, multiplier: 1.060278 },
    { premium: 300000, multiplier: 1.20738 },
    { premium: 400000, multiplier: 1.280931 },
  ],
  "2%|2%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999883 },
    { premium: 150000, multiplier: 0.999903 },
    { premium: 200000, multiplier: 0.999927 },
  ],
  "2%|2%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
  "2%|2%|6 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
  "2%|2%|Lifetime": [
    { premium: 50000, multiplier: 1.00017 },
    { premium: 75000, multiplier: 1.000057 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000102 },
    { premium: 150000, multiplier: 1.000057 },
    { premium: 200000, multiplier: 1.000085 },
  ],
  "3%|3%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1.000079 },
  ],
  "3%|3%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1.000109 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000066 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
  "3%|3%|6 Years": [
    { premium: 50000, multiplier: 1.000183 },
    { premium: 75000, multiplier: 1.000183 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000037 },
    { premium: 150000, multiplier: 1.000061 },
    { premium: 200000, multiplier: 1.000091 },
  ],
  "3%|3%|Lifetime": [
    { premium: 50000, multiplier: 0.999814 },
    { premium: 75000, multiplier: 0.999938 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999888 },
    { premium: 150000, multiplier: 0.999938 },
    { premium: 200000, multiplier: 0.999907 },
  ],
  "5%|5%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.99985 },
    { premium: 150000, multiplier: 0.999875 },
  ],
  "5%|5%|4 Years": [
    { premium: 50000, multiplier: 1.000195 },
    { premium: 75000, multiplier: 1.000065 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000117 },
    { premium: 150000, multiplier: 1.000065 },
  ],
  "5%|5%|6 Years": [
    { premium: 50000, multiplier: 0.99978 },
    { premium: 75000, multiplier: 1.000073 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999956 },
    { premium: 150000, multiplier: 0.999927 },
    { premium: 200000, multiplier: 1 },
  ],
  "5%|5%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
};

const OA_SINGLE_PAY_JOINT_LIFE_BANDS: ConfigBands = {
  "None|None|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000072 },
    { premium: 150000, multiplier: 1.00006 },
    { premium: 200000, multiplier: 1.000045 },
    { premium: 300000, multiplier: 1.07124 },
  ],
  "None|None|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.071864 },
  ],
  "None|None|6 Years": [
    { premium: 50000, multiplier: 1.000121 },
    { premium: 75000, multiplier: 1.00004 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999976 },
    { premium: 150000, multiplier: 1.00004 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1 },
    { premium: 400000, multiplier: 1.176956 },
  ],
  "None|None|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1.000088 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000053 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1 },
    { premium: 400000, multiplier: 1.156324 },
  ],
  "None|2%|2 Years": [
    { premium: 50000, multiplier: 0.999901 },
    { premium: 75000, multiplier: 0.999967 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.00002 },
    { premium: 150000, multiplier: 0.999967 },
    { premium: 200000, multiplier: 1.065861 },
    { premium: 300000, multiplier: 1.180069 },
  ],
  "None|2%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.999925 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999955 },
    { premium: 150000, multiplier: 0.999925 },
    { premium: 200000, multiplier: 1.029622 },
    { premium: 300000, multiplier: 1.218273 },
  ],
  "None|2%|6 Years": [
    { premium: 50000, multiplier: 1.000142 },
    { premium: 75000, multiplier: 1.000142 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000028 },
    { premium: 150000, multiplier: 1.000047 },
    { premium: 200000, multiplier: 1.000071 },
    { premium: 300000, multiplier: 1.199753 },
    { premium: 400000, multiplier: 1.407642 },
  ],
  "None|2%|Lifetime": [
    { premium: 50000, multiplier: 1.000155 },
    { premium: 75000, multiplier: 1.000052 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000093 },
    { premium: 150000, multiplier: 1.000052 },
    { premium: 200000, multiplier: 1.000077 },
    { premium: 300000, multiplier: 1.147838 },
    { premium: 400000, multiplier: 1.413877 },
  ],
  "None|3%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1.011307 },
    { premium: 200000, multiplier: 1.132067 },
    { premium: 300000, multiplier: 1.252862 },
  ],
  "None|3%|4 Years": [
    { premium: 50000, multiplier: 1.00012 },
    { premium: 75000, multiplier: 1.00012 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000024 },
    { premium: 150000, multiplier: 1.00004 },
    { premium: 200000, multiplier: 1.11341 },
    { premium: 300000, multiplier: 1.314492 },
  ],
  "None|3%|6 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.999895 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999937 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
    { premium: 300000, multiplier: 1.331184 },
    { premium: 400000, multiplier: 1.559689 },
  ],
  "None|3%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999863 },
    { premium: 150000, multiplier: 0.999885 },
    { premium: 200000, multiplier: 0.999914 },
    { premium: 300000, multiplier: 1.287686 },
    { premium: 400000, multiplier: 1.578952 },
  ],
  "None|5%|2 Years": [
    { premium: 50000, multiplier: 1.00012 },
    { premium: 75000, multiplier: 1.00004 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.030049 },
    { premium: 150000, multiplier: 1.143142 },
    { premium: 200000, multiplier: 1.284628 },
    { premium: 300000, multiplier: 1.426035 },
  ],
  "None|5%|4 Years": [
    { premium: 50000, multiplier: 1.000141 },
    { premium: 75000, multiplier: 0.999953 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000028 },
    { premium: 150000, multiplier: 1.061123 },
    { premium: 200000, multiplier: 1.298802 },
    { premium: 300000, multiplier: 1.536481 },
  ],
  "None|5%|6 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1.070702 },
    { premium: 300000, multiplier: 1.626695 },
    { premium: 400000, multiplier: 1.904739 },
  ],
  "None|5%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000168 },
    { premium: 150000, multiplier: 1.00014 },
    { premium: 200000, multiplier: 1.000105 },
    { premium: 300000, multiplier: 1.600112 },
    { premium: 400000, multiplier: 1.948511 },
  ],
  "2%|2%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.99992 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999952 },
    { premium: 150000, multiplier: 0.99992 },
    { premium: 200000, multiplier: 0.99994 },
  ],
  "2%|2%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.999911 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999947 },
    { premium: 150000, multiplier: 0.999911 },
    { premium: 200000, multiplier: 0.999933 },
  ],
  "2%|2%|6 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1.000109 },
    { premium: 200000, multiplier: 1.000082 },
  ],
  "2%|2%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 0.999912 },
    { premium: 300000, multiplier: 0.999941 },
  ],
  "3%|3%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
  ],
  "3%|3%|4 Years": [
    { premium: 50000, multiplier: 1.000156 },
    { premium: 75000, multiplier: 0.999948 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000031 },
    { premium: 150000, multiplier: 1.000052 },
    { premium: 200000, multiplier: 1 },
  ],
  "3%|3%|6 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
  "3%|3%|Lifetime": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.999862 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999917 },
    { premium: 150000, multiplier: 0.999862 },
    { premium: 200000, multiplier: 0.999896 },
  ],
  "5%|5%|2 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 0.999872 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999923 },
    { premium: 150000, multiplier: 1 },
  ],
  "5%|5%|4 Years": [
    { premium: 50000, multiplier: 1 },
    { premium: 75000, multiplier: 1.000142 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 1.000085 },
    { premium: 150000, multiplier: 1 },
    { premium: 200000, multiplier: 1 },
  ],
  "5%|5%|6 Years": [
    { premium: 50000, multiplier: 1.100026 },
    { premium: 75000, multiplier: 0.999736 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999947 },
    { premium: 150000, multiplier: 0.999912 },
    { premium: 200000, multiplier: 0.999868 },
  ],
  "5%|5%|Lifetime": [
    { premium: 50000, multiplier: 1.180051 },
    { premium: 75000, multiplier: 0.999718 },
    { premium: 100000, multiplier: 1 },
    { premium: 125000, multiplier: 0.999944 },
    { premium: 150000, multiplier: 0.999906 },
    { premium: 200000, multiplier: 0.999859 },
  ],
};

const OA_10PAY_SINGLE_LIFE_BANDS: ConfigBands = {
  "None|None|2 Years": [
    { premium: 5000, multiplier: 0.979989 },
    { premium: 7500, multiplier: 0.999941 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999941 },
    { premium: 15500, multiplier: 0.999903 },
    { premium: 20000, multiplier: 0.999911 },
    { premium: 25000, multiplier: 0.999965 },
    { premium: 30000, multiplier: 0.999941 },
  ],
  "None|None|4 Years": [
    { premium: 5000, multiplier: 0.979978 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000035 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|None|6 Years": [
    { premium: 5000, multiplier: 0.980182 },
    { premium: 7500, multiplier: 0.986656 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000089 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000079 },
    { premium: 30000, multiplier: 1.000066 },
  ],
  "None|None|Lifetime": [
    { premium: 5000, multiplier: 0.980036 },
    { premium: 7500, multiplier: 0.986758 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000067 },
    { premium: 15500, multiplier: 1.000072 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.00004 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|2%|2 Years": [
    { premium: 5000, multiplier: 0.980128 },
    { premium: 7500, multiplier: 0.986691 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000061 },
    { premium: 15500, multiplier: 1.000029 },
    { premium: 20000, multiplier: 1.000091 },
    { premium: 25000, multiplier: 1.000036 },
    { premium: 30000, multiplier: 1.000061 },
  ],
  "None|2%|4 Years": [
    { premium: 5000, multiplier: 0.979977 },
    { premium: 7500, multiplier: 0.986777 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000126 },
    { premium: 15500, multiplier: 1.000037 },
    { premium: 20000, multiplier: 1.000094 },
    { premium: 25000, multiplier: 1.000076 },
    { premium: 30000, multiplier: 1.000063 },
  ],
  "None|2%|6 Years": [
    { premium: 5000, multiplier: 0.980004 },
    { premium: 7500, multiplier: 0.98674 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.00007 },
    { premium: 15500, multiplier: 0.999993 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000042 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|2%|Lifetime": [
    { premium: 5000, multiplier: 0.980039 },
    { premium: 7500, multiplier: 0.986478 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999928 },
    { premium: 15500, multiplier: 0.999938 },
    { premium: 20000, multiplier: 0.999893 },
    { premium: 25000, multiplier: 0.999957 },
    { premium: 30000, multiplier: 0.999928 },
  ],
  "None|3%|2 Years": [
    { premium: 5000, multiplier: 0.979963 },
    { premium: 7500, multiplier: 0.986518 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999876 },
    { premium: 15500, multiplier: 0.99994 },
    { premium: 20000, multiplier: 0.999907 },
    { premium: 25000, multiplier: 0.999926 },
    { premium: 30000, multiplier: 1.017563 },
  ],
  "None|3%|4 Years": [
    { premium: 5000, multiplier: 0.979853 },
    { premium: 7500, multiplier: 0.986698 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 0.999988 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1 },
    { premium: 30000, multiplier: 1.017371 },
  ],
  "None|3%|6 Years": [
    { premium: 5000, multiplier: 0.980101 },
    { premium: 7500, multiplier: 0.986661 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999927 },
    { premium: 15500, multiplier: 0.999979 },
    { premium: 20000, multiplier: 0.999891 },
    { premium: 25000, multiplier: 0.999956 },
    { premium: 30000, multiplier: 0.999927 },
  ],
  "None|3%|Lifetime": [
    { premium: 5000, multiplier: 0.980112 },
    { premium: 7500, multiplier: 0.986518 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999926 },
    { premium: 15500, multiplier: 0.999964 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 0.999955 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|5%|2 Years": [
    { premium: 5000, multiplier: 0.979829 },
    { premium: 7500, multiplier: 0.986811 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000025 },
    { premium: 20000, multiplier: 1.005528 },
    { premium: 25000, multiplier: 1.04104 },
    { premium: 30000, multiplier: 1.06465 },
  ],
  "None|5%|4 Years": [
    { premium: 5000, multiplier: 0.979825 },
    { premium: 7500, multiplier: 0.986618 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999932 },
    { premium: 15500, multiplier: 0.999888 },
    { premium: 20000, multiplier: 0.999898 },
    { premium: 25000, multiplier: 1.044793 },
    { premium: 30000, multiplier: 1.077848 },
  ],
  "None|5%|6 Years": [
    { premium: 5000, multiplier: 0.99073 },
    { premium: 7500, multiplier: 0.98661 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000079 },
    { premium: 15500, multiplier: 1.000023 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.022106 },
    { premium: 30000, multiplier: 1.093416 },
  ],
  "None|5%|Lifetime": [
    { premium: 5000, multiplier: 1.020318 },
    { premium: 7500, multiplier: 0.996491 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010037 },
    { premium: 15500, multiplier: 1.009989 },
    { premium: 20000, multiplier: 1.010037 },
    { premium: 25000, multiplier: 1.024725 },
    { premium: 30000, multiplier: 1.102734 },
  ],
  "2%|2%|2 Years": [
    { premium: 5000, multiplier: 0.980266 },
    { premium: 7500, multiplier: 0.98671 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000091 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000081 },
    { premium: 30000, multiplier: 1.000067 },
  ],
  "2%|2%|4 Years": [
    { premium: 5000, multiplier: 0.979829 },
    { premium: 7500, multiplier: 0.986761 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000069 },
    { premium: 15500, multiplier: 1.000007 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000042 },
    { premium: 30000, multiplier: 1.000069 },
  ],
  "2%|2%|6 Years": [
    { premium: 5000, multiplier: 0.980032 },
    { premium: 7500, multiplier: 0.986612 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999923 },
    { premium: 15500, multiplier: 0.999948 },
    { premium: 20000, multiplier: 0.999885 },
    { premium: 25000, multiplier: 0.999954 },
    { premium: 30000, multiplier: 0.999923 },
  ],
  "2%|2%|Lifetime": [
    { premium: 5000, multiplier: 0.980136 },
    { premium: 7500, multiplier: 0.986523 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999922 },
    { premium: 15500, multiplier: 0.999932 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 0.999953 },
    { premium: 30000, multiplier: 0.999922 },
  ],
  "3%|3%|2 Years": [
    { premium: 5000, multiplier: 0.980282 },
    { premium: 7500, multiplier: 0.986638 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000072 },
    { premium: 15500, multiplier: 1.000105 },
    { premium: 20000, multiplier: 1.000108 },
    { premium: 25000, multiplier: 1.000043 },
    { premium: 30000, multiplier: 1.000072 },
  ],
  "3%|3%|4 Years": [
    { premium: 5000, multiplier: 0.979987 },
    { premium: 7500, multiplier: 0.986733 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000075 },
    { premium: 15500, multiplier: 1.000022 },
    { premium: 20000, multiplier: 1.000112 },
    { premium: 25000, multiplier: 1.000045 },
    { premium: 30000, multiplier: 1.000075 },
  ],
  "3%|3%|6 Years": [
    { premium: 5000, multiplier: 1.051728 },
    { premium: 7500, multiplier: 0.996551 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010009 },
    { premium: 15500, multiplier: 1.01015 },
    { premium: 20000, multiplier: 1.010093 },
    { premium: 25000, multiplier: 1.010043 },
    { premium: 30000, multiplier: 1.010093 },
  ],
  "3%|3%|Lifetime": [
    { premium: 5000, multiplier: 1.071741 },
    { premium: 7500, multiplier: 0.996657 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010028 },
    { premium: 15500, multiplier: 1.009962 },
    { premium: 20000, multiplier: 1.010028 },
    { premium: 25000, multiplier: 1.010028 },
    { premium: 30000, multiplier: 1.010028 },
  ],
  "5%|5%|2 Years": [
    { premium: 5000, multiplier: 1.073397 },
    { premium: 7500, multiplier: 0.99648 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010044 },
    { premium: 15500, multiplier: 1.010027 },
    { premium: 20000, multiplier: 1.010044 },
    { premium: 25000, multiplier: 1.010044 },
  ],
  "5%|5%|4 Years": [
    { premium: 5000, multiplier: 1.115035 },
    { premium: 7500, multiplier: 0.996611 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010166 },
    { premium: 15500, multiplier: 1.0102 },
    { premium: 20000, multiplier: 1.010166 },
    { premium: 25000, multiplier: 1.010166 },
  ],
  "5%|5%|6 Years": [
    { premium: 5000, multiplier: 1.257695 },
    { premium: 7500, multiplier: 0.99658 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010058 },
    { premium: 15500, multiplier: 1.010182 },
    { premium: 20000, multiplier: 1.010109 },
    { premium: 25000, multiplier: 1.010139 },
  ],
  "5%|5%|Lifetime": [
    { premium: 5000, multiplier: 1.277352 },
    { premium: 7500, multiplier: 0.996629 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010113 },
    { premium: 15500, multiplier: 1.010153 },
    { premium: 20000, multiplier: 1.010113 },
    { premium: 25000, multiplier: 1.010113 },
    { premium: 30000, multiplier: 1.010113 },
  ],
};

const OA_10PAY_JOINT_LIFE_BANDS: ConfigBands = {
  "None|None|2 Years": [
    { premium: 5000, multiplier: 0.980142 },
    { premium: 7500, multiplier: 1.000046 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000046 },
    { premium: 15500, multiplier: 1.00004 },
    { premium: 20000, multiplier: 1.000069 },
    { premium: 25000, multiplier: 1.000028 },
    { premium: 30000, multiplier: 1.000046 },
  ],
  "None|None|4 Years": [
    { premium: 5000, multiplier: 0.980084 },
    { premium: 7500, multiplier: 1 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000101 },
    { premium: 15500, multiplier: 1.000058 },
    { premium: 20000, multiplier: 1.000075 },
    { premium: 25000, multiplier: 1.00006 },
    { premium: 30000, multiplier: 1.00005 },
  ],
  "None|None|6 Years": [
    { premium: 5000, multiplier: 0.979825 },
    { premium: 7500, multiplier: 1.00006 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.00006 },
    { premium: 15500, multiplier: 1.000052 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000036 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|None|Lifetime": [
    { premium: 5000, multiplier: 0.979819 },
    { premium: 7500, multiplier: 0.98661 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000064 },
    { premium: 15500, multiplier: 1.000043 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000038 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|2%|2 Years": [
    { premium: 5000, multiplier: 0.979952 },
    { premium: 7500, multiplier: 1 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 0.999981 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 0.99994 },
    { premium: 30000, multiplier: 1.046828 },
  ],
  "None|2%|4 Years": [
    { premium: 5000, multiplier: 0.979917 },
    { premium: 7500, multiplier: 1.000055 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999945 },
    { premium: 15500, multiplier: 0.99992 },
    { premium: 20000, multiplier: 0.999917 },
    { premium: 25000, multiplier: 0.999967 },
    { premium: 30000, multiplier: 1.026777 },
  ],
  "None|2%|6 Years": [
    { premium: 5000, multiplier: 0.979885 },
    { premium: 7500, multiplier: 0.98659 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000053 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|2%|Lifetime": [
    { premium: 5000, multiplier: 0.979764 },
    { premium: 7500, multiplier: 0.986732 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 0.999926 },
    { premium: 15500, multiplier: 0.99995 },
    { premium: 20000, multiplier: 0.999889 },
    { premium: 25000, multiplier: 0.999956 },
    { premium: 30000, multiplier: 0.999926 },
  ],
  "None|3%|2 Years": [
    { premium: 5000, multiplier: 0.979899 },
    { premium: 7500, multiplier: 1 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000061 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.044975 },
    { premium: 30000, multiplier: 1.099665 },
  ],
  "None|3%|4 Years": [
    { premium: 5000, multiplier: 0.979859 },
    { premium: 7500, multiplier: 1 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1 },
    { premium: 20000, multiplier: 0.999912 },
    { premium: 25000, multiplier: 1.005724 },
    { premium: 30000, multiplier: 1.095524 },
  ],
  "None|3%|6 Years": [
    { premium: 5000, multiplier: 0.979875 },
    { premium: 7500, multiplier: 0.986583 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000058 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1 },
    { premium: 30000, multiplier: 1 },
  ],
  "None|3%|Lifetime": [
    { premium: 5000, multiplier: 1.026854 },
    { premium: 7500, multiplier: 0.996633 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010101 },
    { premium: 15500, multiplier: 1.010101 },
    { premium: 20000, multiplier: 1.010101 },
    { premium: 25000, multiplier: 1.010101 },
    { premium: 30000, multiplier: 1.010101 },
  ],
  "None|5%|2 Years": [
    { premium: 5000, multiplier: 0.979807 },
    { premium: 7500, multiplier: 0.999941 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000059 },
    { premium: 15500, multiplier: 1.000085 },
    { premium: 20000, multiplier: 1.065408 },
    { premium: 25000, multiplier: 1.159333 },
    { premium: 30000, multiplier: 1.221949 },
  ],
  "None|5%|4 Years": [
    { premium: 5000, multiplier: 0.979716 },
    { premium: 7500, multiplier: 0.986613 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 0.999935 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.145801 },
    { premium: 30000, multiplier: 1.250439 },
  ],
  "None|5%|6 Years": [
    { premium: 5000, multiplier: 1.131686 },
    { premium: 7500, multiplier: 0.996651 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010046 },
    { premium: 15500, multiplier: 1.010046 },
    { premium: 20000, multiplier: 1.010046 },
    { premium: 25000, multiplier: 1.010046 },
    { premium: 30000, multiplier: 1.151778 },
  ],
  "None|5%|Lifetime": [
    { premium: 5000, multiplier: 1.236428 },
    { premium: 7500, multiplier: 0.996737 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010185 },
    { premium: 15500, multiplier: 1.010325 },
    { premium: 20000, multiplier: 1.010234 },
    { premium: 25000, multiplier: 1.010264 },
    { premium: 30000, multiplier: 1.043805 },
  ],
  "2%|2%|2 Years": [
    { premium: 5000, multiplier: 0.979786 },
    { premium: 7500, multiplier: 1.000059 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000059 },
    { premium: 15500, multiplier: 1.000006 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.000035 },
  ],
  "2%|2%|4 Years": [
    { premium: 5000, multiplier: 0.980015 },
    { premium: 7500, multiplier: 0.986677 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000128 },
    { premium: 15500, multiplier: 1.000099 },
    { premium: 20000, multiplier: 1.000096 },
    { premium: 25000, multiplier: 1.000077 },
    { premium: 30000, multiplier: 1.000064 },
  ],
  "2%|2%|6 Years": [
    { premium: 5000, multiplier: 0.979866 },
    { premium: 7500, multiplier: 0.986809 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.000077 },
    { premium: 15500, multiplier: 1.000067 },
    { premium: 20000, multiplier: 1.000116 },
    { premium: 25000, multiplier: 1.000046 },
    { premium: 30000, multiplier: 1.000077 },
  ],
  "2%|2%|Lifetime": [
    { premium: 5000, multiplier: 1.046447 },
    { premium: 7500, multiplier: 0.996569 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010126 },
    { premium: 15500, multiplier: 1.010099 },
    { premium: 20000, multiplier: 1.010168 },
    { premium: 25000, multiplier: 1.010193 },
    { premium: 30000, multiplier: 1.010126 },
  ],
  "3%|3%|2 Years": [
    { premium: 5000, multiplier: 0.979976 },
    { premium: 7500, multiplier: 0.986784 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 1.000039 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 1.00008 },
  ],
  "3%|3%|4 Years": [
    { premium: 5000, multiplier: 0.979771 },
    { premium: 7500, multiplier: 0.986514 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1 },
    { premium: 15500, multiplier: 0.999943 },
    { premium: 20000, multiplier: 1 },
    { premium: 25000, multiplier: 0.999912 },
    { premium: 30000, multiplier: 0.999927 },
  ],
  "3%|3%|6 Years": [
    { premium: 5000, multiplier: 1.12345 },
    { premium: 7500, multiplier: 0.996945 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010243 },
    { premium: 15500, multiplier: 1.010173 },
    { premium: 20000, multiplier: 1.010243 },
    { premium: 25000, multiplier: 1.010243 },
    { premium: 30000, multiplier: 1.010243 },
  ],
  "3%|3%|Lifetime": [
    { premium: 5000, multiplier: 1.208817 },
    { premium: 7500, multiplier: 0.99652 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010054 },
    { premium: 15500, multiplier: 1.010216 },
    { premium: 20000, multiplier: 1.010151 },
    { premium: 25000, multiplier: 1.010093 },
    { premium: 30000, multiplier: 1.010151 },
  ],
  "5%|5%|2 Years": [
    { premium: 5000, multiplier: 1.10557 },
    { premium: 7500, multiplier: 0.99664 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010256 },
    { premium: 15500, multiplier: 1.010182 },
    { premium: 20000, multiplier: 1.010212 },
    { premium: 25000, multiplier: 1.010292 },
  ],
  "5%|5%|4 Years": [
    { premium: 5000, multiplier: 1.220141 },
    { premium: 7500, multiplier: 0.996487 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010148 },
    { premium: 15500, multiplier: 1.010048 },
    { premium: 20000, multiplier: 1.0101 },
    { premium: 25000, multiplier: 1.01007 },
  ],
  "5%|5%|6 Years": [
    { premium: 5000, multiplier: 1.498203 },
    { premium: 7500, multiplier: 0.998802 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.010304 },
    { premium: 15500, multiplier: 1.010181 },
    { premium: 20000, multiplier: 1.010244 },
    { premium: 25000, multiplier: 1.010208 },
    { premium: 30000, multiplier: 1.010304 },
  ],
  "5%|5%|Lifetime": [
    { premium: 5000, multiplier: 1.602461 },
    { premium: 7500, multiplier: 1.068307 },
    { premium: 10000, multiplier: 1 },
    { premium: 15000, multiplier: 1.00346 },
    { premium: 15500, multiplier: 1.003584 },
    { premium: 20000, multiplier: 1.010188 },
    { premium: 25000, multiplier: 1.010073 },
    { premium: 30000, multiplier: 1.010124 },
  ],
};

const OA_PRODUCT_BANDS: Record<string, ConfigBands> = {
  sp_single: OA_SINGLE_PAY_SINGLE_LIFE_BANDS,
  sp_joint: OA_SINGLE_PAY_JOINT_LIFE_BANDS,
  "10pay_single": OA_10PAY_SINGLE_LIFE_BANDS,
  "10pay_joint": OA_10PAY_JOINT_LIFE_BANDS,
};

const OA_ASSET_CARE_TYPES = new Set([
  FundingPolicyType.assetCare,
  FundingPolicyType.jointAssetCare,
]);

const OA_JOINT_TYPES = new Set([
  FundingPolicyType.jointAssetCare,
]);

export function isOneAmericaAssetCare(fundingPolicyType: number): boolean {
  return OA_ASSET_CARE_TYPES.has(fundingPolicyType);
}

function normalizeInflationValue(value: string | undefined | null): string {
  if (!value || value === "null" || value.trim() === "") return "None";
  return value;
}

function resolveProductKey(
  fundingPolicyType: number,
  productFundingOption: string | undefined,
): string {
  const isJoint = OA_JOINT_TYPES.has(fundingPolicyType);
  const is10Pay =
    productFundingOption?.toLowerCase().includes("recurring") ||
    productFundingOption?.toLowerCase().includes("10");
  if (is10Pay) return isJoint ? "10pay_joint" : "10pay_single";
  return isJoint ? "sp_joint" : "sp_single";
}

function buildConfigKey(
  aobInflation: string | undefined | null,
  cobInflation: string | undefined | null,
  cobDuration: string | undefined | null,
): string {
  const aob = normalizeInflationValue(aobInflation);
  const cob = normalizeInflationValue(cobInflation);
  const dur = cobDuration?.trim() || "2 Years";
  return `${aob}|${cob}|${dur}`;
}

function interpolateMultiplier(bands: BandEntry[], premium: number): number {
  if (bands.length === 0) return 1.0;
  if (premium <= bands[0].premium) return bands[0].multiplier;
  if (premium >= bands[bands.length - 1].premium) return bands[bands.length - 1].multiplier;

  for (let i = 0; i < bands.length - 1; i++) {
    if (premium >= bands[i].premium && premium < bands[i + 1].premium) {
      const t =
        (premium - bands[i].premium) / (bands[i + 1].premium - bands[i].premium);
      return bands[i].multiplier + t * (bands[i + 1].multiplier - bands[i].multiplier);
    }
  }

  return 1.0;
}

/**
 * Returns the interpolated multiplier for a OneAmerica AssetCare quote.
 * Uses the quote's inflation/duration config to find the correct band,
 * then interpolates between known premium data points.
 */
export function getOAMultiplierForPremium(
  fundingPolicyType: number,
  productFundingOption: string | undefined,
  aobInflation: string | undefined | null,
  cobInflation: string | undefined | null,
  cobDuration: string | undefined | null,
  premium: number,
): number {
  const productKey = resolveProductKey(fundingPolicyType, productFundingOption);
  const configKey = buildConfigKey(aobInflation, cobInflation, cobDuration);
  const configBands = OA_PRODUCT_BANDS[productKey];
  if (!configBands) return 1.0;

  const bands = configBands[configKey];
  if (!bands) return 1.0;

  return interpolateMultiplier(bands, premium);
}
